import { userRequest } from '../requestMethods';
import config from '../config';

const DOMAIN = config.REACT_APP_SERVER_DOMAIN;

export const getBudget = async () => {
    return userRequest.get(`${DOMAIN}/api/budget`);
  };


export const getBudgetOne = async (id) => {
    return userRequest.get(`${DOMAIN}/api/budget/one?id_budget=${id}`);
  };

export const postBudget = async (data) => {
  return userRequest.post(`${DOMAIN}/api/budget`, data);
};

export const putBudget = async (id, data) => {
    return userRequest.put(`${DOMAIN}/api/budget`, {
        id_budget: id,
        ...data
      });
  };
  
export const deletePutBudget = async (id) => {
    return userRequest.put(`${DOMAIN}/api/budget/putSupprime?id=${id}`);
  };

export const deleteBudget = async (id) => {
    return userRequest.delete(`${DOMAIN}/api/budget/${id}`);
  };